import React, { useEffect } from 'react';

import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { payNowUrl } from '../../../lib/constants/SiteVariables';
import { updateParent } from '../../../lib/utils/modal';
import PayNowOption from '../../shared/PayNowOption';
import ReturnToMerchant from '../../shared/ReturnToMerchant';
import Support from '../../shared/Support';

export default function Declined({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      if (cart && cart.cancel_url && session.strategy !== 'async') {
        window.location.href = cart.cancel_url;
      } else if (merchant !== undefined) {
        window.location.href = merchant.url;
      } else {
        window.location.href = '/';
      }
    }
  };

  const handlePayNowContinue = () => {
    if (payNowUrl) {
      window.location.href = payNowUrl;
    }
  };

  const showPayNowOption = Boolean(
    cart &&
      merchant &&
      merchant.supports_pay_now &&
      merchant.supports_pay_now_on_decline
  );

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      <p className="text-xs uppercase tracking-widest font-bold text-secondary-gray">
        Application Complete
      </p>
      <h1 className="my-4 text-2xl sm:text-4xl font-extrabold">
        We're unable to approve your application
      </h1>
      <p className="tracking-wide font-light sm:text-lg mb-4">
        You'll receive an email shortly with details about the decision and next
        steps.
      </p>
      <p className="tracking-wide font-light sm:text-lg mb-6">
        Please check your inbox.
      </p>
      <hr className="border-t border-primary-border-gray mb-6" />

      {showPayNowOption && <PayNowOption onContinue={handlePayNowContinue} />}

      <div className="my-4 sm:my-10">
        <ReturnToMerchant
          merchant={merchant}
          redirect={redirect}
          asButton={true}
        />
      </div>
      <Support declined={true} />
    </div>
  );
}
